/**
 * Auth state snapshot for log lines outside AuthService (#3576 / #3577).
 *
 * `api-utils` cannot import AuthService (import cycle through the API
 * layer), so AuthService registers a describer here and anyone logging a
 * failed request asks for the current state through it.
 */

export interface AuthStateSnapshot {
  hasSession: boolean;
  needsReauth: boolean;
  /** decoded lifetime of the access token, never the token itself */
  access: unknown;
  refresh: unknown;
  /** ISO time of the last successful access-token refresh in this tab */
  lastRefreshAt: string | null;
  refreshInFlight: boolean;
  /** how long the document was hidden before it last became visible */
  lastHiddenForMs: number | null;
  /** ISO time the document last became visible */
  lastVisibleAt: string | null;
}

let describer: (() => AuthStateSnapshot) | null = null;

export function setAuthStateDescriber(fn: () => AuthStateSnapshot): void {
  describer = fn;
}

export function describeAuthState(): AuthStateSnapshot | null {
  try {
    return describer ? describer() : null;
  } catch {
    return null;
  }
}
